module.exports = __webpack_public_path__ + "img/Logo.64d54e95.png";